module.exports = __webpack_public_path__ + "static/BinanceCard-590c97a7034f473e73fa944527b5e412.png";